import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'

export const TEAM_BADGES_QUERY_KEY = (teamID: string) => ['badges', 'team', teamID]

export function useTeamBadges(teamID: string) {
  return useQuery({
    queryKey: TEAM_BADGES_QUERY_KEY(teamID),
    queryFn: () => dataSource.getTeamBadges(teamID),
    enabled: !!teamID,
    staleTime: 0,
    gcTime: 0,
  })
}
